import { CATEGORIAS } from '../constants/formConfig';

// ── Barra de filtros ─────────────────────────────────────────────
export const FiltroCategorias = ({ filtro, setFiltro, counts }) => (
  <div className="flex gap-2 overflow-x-auto pb-1">
    {CATEGORIAS.map(cat => (
      <button
        key={cat}
        onClick={() => setFiltro(cat)}
        className={`px-3 py-1.5 rounded-full text-xs font-bold whitespace-nowrap transition-all border ${filtro === cat ? "bg-blue-600 text-white border-blue-600" : "bg-white text-gray-600 border-gray-300 hover:bg-blue-50"}`}
      >
        {cat}{counts && counts[cat] !== undefined ? ` (${counts[cat]})` : ""}
      </button>
    ))}
  </div>
);
